/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { GetOpeningsData, PractitionersSearchRequest, SearchData } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Practitioners<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags practitioners-controller
   * @name Search
   * @request POST:/practitioners/search
   */
  search = (data: PractitionersSearchRequest, params: RequestParams = {}) =>
    this.request<SearchData, any>({
      path: `/practitioners/search`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags practitioners-controller
   * @name GetOpenings
   * @request GET:/practitioners/{staffMemberGuid}/location/{locationId}/openings
   */
  getOpenings = (staffMemberGuid: string, locationId: number, params: RequestParams = {}) =>
    this.request<GetOpeningsData, any>({
      path: `/practitioners/${staffMemberGuid}/location/${locationId}/openings`,
      method: 'GET',
      ...params,
    });
}
